import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Badge from '@material-ui/core/Badge';
import SystemLabel from '../../../../../system/SystemLabel/SystemLabel';
import SpeakerList from './SpeakerList';

export function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={1}>{children}</Box>}
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    badge: {
        marginLeft: 20
    }
}));

export default function SpeakerTabs(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const { selectedQuestion, orderList, clientList, speakers, activateSpeaker } = props;
    let filteredSpeakers = props.speakers && props.agendaSpeakers ? props.speakers.filter(s => s.agendaItemId === props.agendaSpeakers.agendaItemId) : []
    let filteredClients = orderList.filter(ia => filteredSpeakers.find(s => s.badgeNo === ia.badgeNo))


    return <div className={classes.root}>
        {orderList.length > 0 ? (
            <SpeakerList
                parentId={props.parentId}
                speakers={filteredSpeakers}
                activateSpeaker={activateSpeaker}
                filteredClients={filteredClients}
                setSpeaker={props.setSpeaker}
                removeSpeaker={props.removeSpeaker}
                activeAgenda={props.activeAgenda}
                agendaItemId={props.agendaSpeakers ? props.agendaSpeakers.agendaItemId : null}
                allClients={orderList}
                clientList={props.clientList} />
        ) : null}
    </div >
}